import script from "./CreateDriverModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateDriverModal.vue?vue&type=script&setup=true&lang=ts"

import "./CreateDriverModal.vue?vue&type=style&index=0&id=174feb2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-174feb2a"]])

export default __exports__